import { Container } from "react-bootstrap";

const OurPartners = ({ data }) => {

  return (
    <div className="w-100 p-0 m-0">
      <Container className="d-flex justify-content-center">
        <div
          className="col-10 d-flex flex-column justify-content-center align-items-center m-0"
          style={{
            padding: "80px 0px",
            rowGap: "2rem",
          }}
        >
          <h1 className="fw-bold" style={{ fontSize: "36px" }}>
            Some of our partners and clients
          </h1>
          <div className="d-flex flex-wrap justify-content-center gap-4">
          {data.map((item, index) => {

            const { partner_name, partner_logo } = item;

            return (
              <div key={index} className="col-2">
                <img src={partner_logo} alt={partner_name} className="w-100" />
              </div>
            );
          })}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default OurPartners;
